import React, { useState } from 'react';
import { parse, stringify } from 'query-string';
import moment from 'moment-timezone';
import useStewardshipFilter from '../../offers/useStewardshipFilter';
import REQUIRED_FIELDS from '../../offers/REQUIRED_FIELDS';
import { useConnect } from '../../../../hooks/@lore/query-connect';
import _ from 'lodash';

export default function useQuery(props) {
  const { location, PAGE_SIZE = 10, extra = {} } = props;

  const [timestamp] = useState(moment().toISOString());
  const stewardshipFilter = useStewardshipFilter();

  return useConnect('offer.find', {
    where: {
      eager: {
        $where: {
          $and: _.remove([
            ...REQUIRED_FIELDS.$and,
            stewardshipFilter ? {
              $or: stewardshipFilter,
            } : undefined
          ]),
          $or: [
            {
              specificDate: 'Yes',
              date: {
                $lte: moment(timestamp).toISOString(),
                // $gte: moment(timestamp).subtract(4, 'weeks').toISOString()
              }
            },
            {
              specificDate: 'No',
              endDate: {
                $lte: moment(timestamp).toISOString(),
                // $gte: moment(timestamp).subtract(4, 'weeks').toISOString()
              }
            }
          ],
          cancelled: false,
          completed: false,
          ...extra
        }
      }
    },
    pagination: {
      page: parse(location.search).page || '1',
      pageSize: PAGE_SIZE,
      order: 'createdAt desc'
    }
  }, {
    keepPreviousData: true
  });
}
